<template>
  <div id="content-home">
  
    <section class="banner-home" >
      <div class="banner-home-title">
        <h1>
          <span class="sub-title light">votre nouvelle</span><br />
          <span class="thin">web agency</span><br />
          <span class="sub-title home light">Sites internet <span class="boule"></span> e-commerce <span class="boule"></span> Inbound Marketing</span>
        </h1>

        <div class="sub-text light">
          Nous concevons et développons pour nos clients des sites Internet et des solutions Web avancées, certes…<br />
          Mais nous vous aidons aussi à faire en sorte que ces outils soient visités, utilisés et appréciés par votre audience cible !
        </div>
      </div>
      <div class="banner-scroll">        
          <img src="./../../assets/scroll-btn.png" v-scroll-to="'#home1'"  alt="bouton scroll" />     
      </div> 
      <div id="particles-js"></div>
      <img class="sep" src="./../../assets/bg-triangle-middle-s3dweb.png" alt="sep"  />
    </section> 

    <section id="home1" class="bg-white">
      <div class="content-text">
        <p class="text-big bold">SYNTHES’3D WEB est la filiale dédiée « Web »<br /> de la société SYNTHES’3D, studio digital depuis 2007 !</p>
        <p class="regular">Nous accompagnons tous nos clients sur l’ensemble de leur problématique Internet :<br />
         de la conception de leurs sites Internet et/ou plateformes Web<br /> jusqu’à leur optimisation et suivi au quotidien une fois déployé.
        </p>
      </div>
    </section>

    <section class="section-solutions bg-static">

      <div class="bg-move"></div>

      <img class="sep" src="./../../assets/bg-triangle-top-s3dweb.png" alt="sep" />

      <h2 class="white thin">DÉCOUVREZ NOS SOLUTIONS</h2>
      
      <div class="solutions-container">

        <div class="solutions-item">
          <div class="solutions-title">
            <h3 class="light">Site internet<br /><span class="solutions-sub-title regular">VITRINE</span></h3>
          </div>
          <div class="solutions-img">
            <img src="./../../assets/solutions_s3d_1.png" alt="site internet vitrine" />
          </div>
          <div class="solutions-infos">
            <p class="solutions-infos-title">Entrez dans la lumière<br /> et signifiez au monde votre présence !</p>
            <p>Dotez-vous d'un site Internet vitrine dernière génération.</p>
            <router-link to="./solutions#vitrine" class="btn-main">En savoir plus</router-link> 
          </div>
        </div>

        <div class="sep-orange sep-solutions "></div>

        <div class="solutions-item">
          <div class="solutions-title">
            <h3 class="light">Boutique<br /><span class="solutions-sub-title regular">e-commerce</span></h3>
          </div>
          <div class="solutions-img">
            <img src="./../../assets/solutions_s3d_2.png" alt="site internet vitrine" />
          </div>
          <div class="solutions-infos">
            <p class="solutions-infos-title">Offrez du choix à vos clients<br /> et faîtes la promotion de vos produits !</p>
            <p>Lancez votre boutique en ligne et commercialisez vos produits aux internautes du monde entier.</p>
            <router-link to="./solutions#boutique" class="btn-main">En savoir plus</router-link>
          </div>
        </div>

        <div class="sep-orange sep-solutions "></div>

        <div class="solutions-item">
          <div class="solutions-title">
            <h3 class="light">Applications Web<br /><span class="solutions-sub-title regular">sur mesure</span></h3>
          </div>
          <div class="solutions-img">
            <img src="./../../assets/solutions_s3d_3.png" alt="site internet vitrine" />
          </div>
          <div class="solutions-infos">
            <p class="solutions-infos-title">Disposez d'une solution<br /> et d'un design sur mesure !</p>
            <p>Concevez et construisez votre application Web sur mesure répondant à 100% de vos besoins métiers.</p>
            <router-link to="./solutions#appli" class="btn-main">En savoir plus</router-link>
          </div>
        </div>

      </div>

      <img class="sep" src="./../../assets/bg-triangle-bottom-s3dweb.png" alt="sep"  />

    </section>

    <section class="section-services" >
  
      <DiscoverService></DiscoverService>

      <h2 class="thin">DÉCOUVREZ NOS RÉALISATIONS</h2>

    </section>

    <PortfolioGrid :portfolio=8 :remove=[0,1,3,4,5,7,8,10]></PortfolioGrid>

      <section class="bg-white-home section-last">
      <!-- <div class="sep-boules">
        <div class="boule"></div>
        <div class="boule"></div>
        <div class="boule"></div>
        <div class="boule"></div>
        <div class="boule"></div>
        <div class="boule"></div>
      </div> -->
      <div class="content-text">
        <h2 class="text-big">Une idée ? Un projet ?</h2>
        <p>Vous souhaitez obtenir des renseignements sur nos solutions Web, nos options et nos services ?<br />
        Vous avez besoin d’un devis pour l’un de vos projets ?<br />
        <span class="bold">Contactez-nous !</span></p>
        <div class="list-contact-container">
          <div class="list-contact-bg"></div>
          <router-link to="/contact">
            <img src="./../../assets/logo-contact.png" class="link-contact" alt="logo synthes3d icone" />
          </router-link>
        </div>
      </div>
       <!-- <div class="sep-boules">
        <div class="boule"></div>
        <div class="boule"></div>
        <div class="boule"></div>
        <div class="boule"></div>
        <div class="boule"></div>
        <div class="boule"></div>
      </div> -->
      
    </section>

  </div>


</template>

<script>

import $ from "jquery";
import PortfolioGrid from './../layout/PortfolioGrid'
import DiscoverService from './../layout/DiscoverService'

$(window).on("load resize scroll", function() {
  $(".bg-static").each(function() {
    var windowTop = $(window).scrollTop();
    var elementTop = $(this).offset().top;
    var rightPosition = windowTop - elementTop;
    rightPosition = rightPosition - 2000;
      $(this)
        .find(".bg-move")
        .css({ right: rightPosition });
  });
});

export default {

  props:  {
    portfolio: {
      type : Array,
      default: function () { return [] }
    }
  },

 mounted () {
    this.$nextTick(() => {this.initParticlesJS()})
  },  
  components: {
    PortfolioGrid,
    DiscoverService
  },
  methods: {
    initParticlesJS() {
      window.particlesJS("particles-js", {
        
        "particles": {
          "number": {
            "value": 200,
            "density": {
              "enable": true,
              "value_area": 800
            }
          },
          "color": {
            "value": "#ffffff"
          },
          "shape": {
            "type": "circle",
            "stroke": {
              "width": 0,
              "color": "#000000"
            },
            "polygon": {
              "nb_sides": 5
            },
            "image": {
              "src": "img/github.svg",
              "width": 100,
              "height": 100
            }
          },
          "opacity": {
            "value": 0.7,
            "random": true,
            "anim": {
              "enable": false,
              "speed": 1,
              "opacity_min": 0.1,
              "sync": false
            }
          },
          "size": {
            "value": 3,
            "random": true,
            "anim": {
              "enable": false,
              "speed": 80,
              "size_min": 0.1,
              "sync": false
            }
          },
          "line_linked": {
            "enable": false,
            "distance": 300,
            "color": "#ffffff",
            "opacity": 0.4,
            "width": 2
          },
          "move": {
            "enable": true,
            "speed": 1,
            "direction": "top",
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            "onhover": {
              "enable": true,
              "mode": "repulse"
            },
            "onclick": {
              "enable": true,
              "mode": "push"
            },
            "resize": true
          },
          "modes": {
            "grab": {
              "distance": 800,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 800,
              "size": 80,
              "duration": 2,
              "opacity": 0.8,
              "speed": 3
            },
            "repulse": {
              "distance": 100,
              "duration": 0.4
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        "retina_detect": true
      })
    }
  }
  
  
}


</script>


<style>

.sep {
  width:100%;
  height:auto;
  z-index:10;
  position: relative;
}

.section-last {
  padding-bottom:105px !important;
}

.sep-orange {
  display: none;
}


.banner-home {
  height:100vh;  
  width:100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-image: url('./../../assets/services.png'), linear-gradient(90deg,#ef4337,#fbab37);
  background-position:center right;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  position:relative;
}

.banner-home-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height:100vh;
}

.banner-home-title h1 { 
  font-size:80px;
  color:#ffffff;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 20px;
}

.banner-home-title h1 .sub-title {
  font-size:30px;
  letter-spacing: 10px;
}

.sub-title.home {
  display: flex;
  align-items: center; 
  justify-content: center; 
  margin-top: 10px;
}

.banner-home-title .sub-text {
  font-size:18px;
  color:#ffffff;
  text-align: center; 
  line-height: 30px;
}

.sub-title .boule {
  margin:0 20px;
}

h2 {
  color:#1a1a1a;  
  font-size:30px;
  text-align: center;
  margin-bottom:40px;
}

.white {
  color:#ffffff;
}

.text-big {  
  font-size:30px;
  color:#1a1a1a;
  text-align: center;
  line-height: 1.6em;

}

.banner-logo {
    padding-top: 200px;
}

.banner-scroll {
  padding-bottom: 50px;
  z-index: 999;
}

.banner-scroll  img {
  border-radius:50%;
  transition:0.5s;
    -moz-box-shadow: 0px 0px 20px 0px #1a1a1a;
-webkit-box-shadow: 0px 0px 20px 0px #1a1a1a;
-o-box-shadow: 0px 0px 20px 0px #1a1a1a;
box-shadow: 0px 0px 20px 0px #1a1a1a;
}

.banner-scroll  img:hover {
  cursor:pointer;
  transform: scale(1.1);
      -moz-box-shadow: 0px 0px 5px 0px #1a1a1a;
-webkit-box-shadow: 0px 0px 5px 0px #1a1a1a;
-o-box-shadow: 0px 0px 5px 0px #1a1a1a;
box-shadow: 0px 0px 5px 0px #1a1a1a;

}

.content-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

p {
  color:#8b8b8b;
  font-size:15px;
 
  text-align: center;
  line-height:1.6em;
}

section.bg-white, section.bg-white-home {
  padding:50px 0;
  background: #ffffff;
}

section.bg-white-home {
  background: url('./../../assets/bg-white-parallax.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

#particles-js {
  position: absolute;
  width:100%;
  height:100%;
}

.sep-boules {
  display:flex;
  flex-direction: column;
  align-items: center;
}

.boule {
  width:10px;
  height:10px;
  border-radius: 50%;
  background:#fbab37;
  margin-bottom: 5px;
}

.content-text {
  padding:30px 0;
}


/* solution */

.section-solutions {
  background:#000000;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position:relative;
  overflow: hidden;
}

.bg-move {
  position: absolute;
  top: 0;
  bottom: 0;
  left: auto;
  width: 5000px;
  background-image: url('./../../assets/bg-parallax-home.jpg');
  background-size: cover;
  background-position: center;
  z-index:1;
}

.section-solutions h2 {
  margin-top: 40px;
  z-index: 999999;
  position: relative;
}


.solutions-container {
  display: flex;
  justify-content: center;
  width:95%;
  margin:0 auto;
  z-index:10;
  position: relative;
}

.solutions-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin:40px 1.5%;
  width:30%; 
}

.solutions-title, .solutions-infos, .solutions-img {
  display:flex;
}

.solutions-title {
  justify-content: center;
  
}

.solutions-infos {
  flex-direction: column;
  max-width: 400px;
  align-items: center;
}

.solutions-title h3 {
  color:#ffffff;
  font-size:30px;
  text-align: center;
}

.solutions-title .solutions-sub-title {
  color: #fbab37;
    text-transform: uppercase;
    background: -webkit-gradient(linear,left top,right top,from(#f78c37),to(#fbab37));
    background: linear-gradient(90deg,#f78c37,#fbab37);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.solutions-img {
  padding:0 20px;
}

.solutions-infos p {
  color:#ffffff;
  margin-top:0;
  margin-bottom:0;
  line-height: 30px;
  text-align: center;
  font-size:15px;
}

.solutions-infos-title{
  font-size:18px;
  margin:0;
  font-weight:bold;
}



/* services */

.section-services {
  background:#ffffff;
  margin-top:-5px;
  padding-top:5px;
  position:relative;
  z-index: 99;
}

.services-container {
  display:flex;
  width:1200px;
  margin:80px auto 120px;
}

.services-item {
  width:29%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:0 2%;
}

.services-item p {
  min-height:180px;
}

.services-container h3 {
  color:#1a1a1a;
  font-size:30px;
  text-align: center;
  margin-bottom:20px;
}

.services-container p.services-sub-title {
  color:#8b8b8b;
  font-size:18px;
  text-align: center;
}

.services-container p {
  color:#8b8b8b;
  font-size:15px;
  text-align: center;
  margin: 0;
}

/* contact */

.list-contact-container {
  position:relative;
  height:180px;
  width:180px;
}

.list-contact-bg {
  position:absolute;
  left:calc( 50% - 80px);
  height:160px;
  width:160px;
  background: url('./../../assets/logo-contact-container.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  cursor:pointer;
  transition:0.5s;
}

.link-contact {
  z-index:999;
  position:absolute;
  left:calc( 50% - 80px);
  top:10px;
  height:150px;
  width:150px;
  cursor:pointer;
  transition: 0.5s;
}

.link-contact:hover {
  transform: rotate(360deg);
}

@media screen and (max-width: 767px) {
 
  h2 {
    padding: 0 20px;
  }

  .services-container {
    flex-direction: column;
    max-width:100%;
    margin-bottom:40px;
    margin-top:40px;
  }

  .services-item {
    width:97%;
    padding:0 20px;
    margin: 30px 1.5%;
  }

  .services-item h3, .services-item p {
    padding: 0 20px;
  }

  .banner-home-title .sub-text {
    line-height:22px;
  }

  .content-text {
    padding: 30px 20px;
  }

  .banner-home-title h1 {
    font-size:18px;
  }

  .banner-home-title .sub-title.light {
    font-weight:400;
  }

  .banner-home-title .thin {
    font-weight:200;
    display: block;
  }

  .sub-text.light {
    padding:0 20px;
    font-size:15px;
  }

  .banner-home-title h1 .sub-title {
    font-size:15px;
    padding:0 20px;
    display: block;
    margin:20px 0;
    letter-spacing:10px;
  }
  
  .banner-home-title h1 .sub-title {
    letter-spacing: 5px;
  }

  .sub-title.home {
    flex-direction: column;
  }

  .boule {
    display: block;
    background: none;
  }

  section.bg-white, section.bg-white-home {
    padding: 0;
  }

  .text-big {
    font-size:20px;
  }



}

@media screen and (max-width:1200px) {
  .services-container {
    flex-direction: column;
    max-width:100%;
    margin-bottom:40px;
    margin-top:40px;
  }

  .services-item {
    width:97%;
    padding:0 20px;
    margin: 30px 1.5%;
  }

  .solutions-container {
    flex-direction: column;
  }

  .solutions-item {
    width:97%;
    margin: 30px 1.5%;
  }


  .solutions-title, .solutions-img {
      justify-content: center;
  
  }

    .sep-orange.sep-solutions {
    margin: 20px auto -20px ;
    display: block !important;
  }

  .services-item h3, .services-item p {
    padding: 0 20px;
  }

  .sep-orange {
    height:1px;
    width:80%;
    margin: 20px auto 0 ;
    background: #f78c37;
    display: block;
  }

  .sep-orange.sep-solutions {
    display: none;
  }

  .services-item p {
    min-height:auto;
  }
}





</style>